import { LoadingButton } from '@mui/lab';
import {
  // Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  // IconButton,
  // InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Transition } from '../../components/Transition';
import { LANGUAGE, SETTING_VALUE_TYPE } from '../../constants';
import DeliveryTimeSlotsEditor from './DeliveryTimeSlotsEditor';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

interface IProps {
  toggle: boolean;
  onClose: () => void;
  values: any;
  handleSubmit: () => void;
  setFieldValue: (key: string, value: any) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  resetForm: () => void;
}

const SettingsFormModal: React.FC<IProps> = ({
  toggle,
  onClose,
  errors,
  touched,
  values,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleSubmit,
  resetForm,
}) => {
  const isDeliveryTimeSlots = values.name === 'delivery_time_slots';

  return (
    <Dialog
      fullWidth
      maxWidth={isDeliveryTimeSlots ? 'md' : 'sm'}
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        resetForm();
        onClose();
      }}
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitle sx={{ mt: -0.5, mb: -0.5 }}>Settings</DialogTitle>
      <form
        onSubmit={handleSubmit}
        autoComplete='off'
      >
        <DialogContent dividers>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='name'
                name='name'
                label='Name'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.name}
                error={Boolean(errors.name && touched.name)}
                helperText={Boolean(errors.name && touched.name) && errors.name}
                disabled={values?.id ? true : false}
              />
            </Grid>
            {values.name !== 'cod_active' && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={12}
                >
                  <FormControl
                    fullWidth
                    error={Boolean(touched?.valueType && errors?.valueType)}
                  >
                <InputLabel>{'Type'}</InputLabel>
                <Select
                  name='valueType'
                  labelId='valueType'
                  id='valueType'
                  value={values.valueType}
                  label={'Type'}
                  onChange={(e) => setFieldValue('valueType', e.target.value)}
                  MenuProps={{
                    style: {
                      maxHeight: 400,
                    },
                  }}
                >
                  {SETTING_VALUE_TYPE?.map((type) => (
                    <MenuItem
                      key={type.value}
                      value={type.value}
                    >
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
                {Boolean(touched.valueType && errors.valueType) && (
                  <FormHelperText>{errors?.valueType}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <FormControl
                fullWidth
                error={Boolean(touched?.language && errors?.language)}
              >
                <InputLabel>{'Language'}</InputLabel>
                <Select
                  name='language'
                  labelId='language'
                  id='language'
                  value={values.language}
                  label={'Language'}
                  onChange={(e) => setFieldValue('language', e.target.value)}
                  MenuProps={{
                    style: {
                      maxHeight: 400,
                    },
                  }}
                >
                  {LANGUAGE?.map((type) => (
                    <MenuItem
                      key={type.value}
                      value={type.value}
                    >
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
                {Boolean(touched.language && errors.language) && (
                  <FormHelperText>{errors?.language}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              {isDeliveryTimeSlots ? (
                <DeliveryTimeSlotsEditor
                  key={values.id || 'delivery_time_slots'}
                  value={values.value}
                  onChange={(jsonValue) => setFieldValue('value', jsonValue)}
                  error={Boolean(errors.value && touched.value)}
                  helperText={
                    Boolean(errors.value && touched.value) && errors.value
                  }
                />
              ) : (
                <TextField
                  multiline
                  rows={5}
                  id='value'
                  name='value'
                  label='Value'
                  fullWidth
                  variant='outlined'
                  onChange={handleChange}
                  value={values.value}
                  error={Boolean(errors.value && touched.value)}
                  helperText={
                    Boolean(errors.value && touched.value) && errors.value
                  }
                />
              )}
                </Grid>
              </>
            )}
            <Grid
              item
              xs={12}
              sm={12}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    name='activeState'
                    onChange={(e) =>
                      setFieldValue('activeState', e.target.checked)
                    }
                    checked={values.activeState}
                  />
                }
                label={'Active Status'}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetForm();
              onClose();
            }}
            variant='outlined'
          >
            {'Cancel'}
          </Button>
          <LoadingButton
            type='submit'
            loading={isSubmitting}
            variant='contained'
          >
            {'Save'}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default SettingsFormModal;
